module.exports = __webpack_public_path__ + "static/media/12.320c541d.jpeg";